import React from 'react';
import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const MailContactOption: React.FC = () => {
  const endpoint = '/mail-contact-option';
  const title = 'Tipos de contatos';

  const { projectHash, eventHash } = useParams<Record<string, any>>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },

    title: { ref: 'title', column: 'title', label: 'Título' },
    url: { ref: 'url', column: 'url', label: 'Código' },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {

    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    description: { model: 'richText', type: 'text', name: 'description', label: 'Descritivo' },
    url: { model: 'input', type: 'text', name: 'url', label: 'Código' },

    email: {
      model: 'jsonInputList',
      type: 'text',
      name: 'email',
      label: 'E-mails',
      show: 'title',
      list: [
        { label: 'Título', name: 'title', type: 'input' },
        { label: 'value', name: 'value', type: 'input' },
        { label: 'Subtítulo', name: 'subtitle', type: 'input' },
        {
          label: 'Opções', name: 'options', type: 'jsonList', show: ['title', 'value'], list: [

            { label: 'Título', name: 'title', type: 'input' },
            { label: 'value', name: 'value', type: 'input' },
          ]
        },

        {
          label: 'Campos adicionais', name: 'fields', type: 'jsonList', show: ['title', 'value'], list: [

            { label: 'Nome do campo', name: 'label', type: 'input' },
            { label: 'Código', name: 'name', type: 'input' },
            {
              label: 'Tipo', name: 'type', type: 'select', options: [
                { text: 'Texto', label: 'Texto', value: 'input' },
                { text: 'Seleção', label: 'Seleção', value: 'select' },
                { text: 'Estado', label: 'Estado', value: 'state' },
                { text: 'Texto com Máscara', label: 'Texto com máscara', value: 'masc' },

              ]
            },
            {
              label: 'Opções', name: 'options', type: 'arrayIncluder'
            },
            {
              label: 'Alterar não BR', name: 'no_br', type: 'select', options: [
                { text: 'Sim', label: 'Sim', value: 'yes' },
                { text: 'Não', label: 'Não', value: 'no' },


              ]
            },
            {
              label: 'Obrigatório', name: 'mandatory', type: 'select', options: [
                { text: 'Sim', label: 'Sim', value: 'yes' },
                { text: 'Não', label: 'Não', value: 'no' },


              ]
            },

            {
              label: 'Máscara', name: 'type', type: 'select', options: [
                { text: 'CEP', label: 'CEP', value: '99999999' },

                { text: 'CNPJ', label: 'CNPJ', value: '99.999.999/9999-99' },
                { text: 'CPF', label: 'CPF', value: '999.999.999-99' },
                { text: 'DATA DE NASCIMENTO', label: 'DATA DE NASCIMENTO', value: '99/99/9999' },

              ]
            },
          ]
        }

      ],




    },

    phone: {
      model: 'jsonInputList',
      type: 'text',
      name: 'phone',
      label: 'Telefones',
      show: 'title',
      list: [
        { label: 'Título', name: 'title', type: 'input' },
        { label: 'value', name: 'value', type: 'input' },
      ]
    },
    social: {
      model: 'jsonInputList',
      type: 'text',
      name: 'social',
      label: 'Redes sociais / Whatsapp',
      show: 'title',
      list: [
        { label: 'Título', name: 'title', type: 'input' },
        { label: 'value', name: 'value', type: 'input' },
        {
          label: 'Tipo', name: 'type', type: 'select', options: [
            { text: 'Whatsapp', label: 'Whatsapp', value: 'whatsapp' },
            { text: 'Facebook', label: 'Facebook', value: 'facebook' },
            { text: 'Instagram', label: 'Instagram', value: 'instagram' },
            { text: 'Linkedin', label: 'Linkedin', value: 'linkedin' },
            { text: 'Twitter', label: 'Twitter', value: 'twitter' },
          ]
        },

      ]
    },



  };

  const formSchemaUpdate = {


    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default MailContactOption;
